/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_CODETABLE_DATA = 'GET_CODETABLE_RESULT_DETAILS';
export const POST_CODETABLE_DATA = 'POST_CODETABLE_RESULT_DETAILS';
export const COMPARE_CODETABLE_DATA = 'COMPARE_CODETABLE_DATA';
export const CODETABLE_DATA_ROW_SELECTED = 'CODETABLE_DATA_ROW_SELECTED';
export const CODETABLE_DATA_LOADING = 'CODETABLE_DATA_LOADING';
export const CODE_TABLE_DATA_CHANGE_TRIED = 'CODE_TABLE_DATA_CHANGE_TRIED';
export const CODE_TABLE_ERROR_MESSAGE = 'CODE_TABLE_ERROR_MESSAGE';
export const CODE_TABLE_SUCCESS_MESSAGE = 'CODE_TABLE_SUCCESS_MESSAGE';
export const CHILD_CODE_VALUE_ERROR = 'CHILD_CODE_VALUE_ERROR';
export const RESET_CODETABLE_STORE = 'RESET_CODETABLE_STORE';
export const SET_SELECTED_PARENT_PROTECTED_IND =
  'SET_SELECTED_PARENT_PROTECTED_IND';
export const SELECTED_PARENT_ROW = 'SELECTED_PARENT_ROW';
export const CODE_VALUE_DUPLICATE = 'CODE_VALUE_DUPLICATE';
